export default {
  message: {
    Tour: {
      continue: "Продолжить",
      back: "Назад",
      finish: "Готово"
    },
    Login: {
      title: "Вход для родителей",
      sign_in: "Войти",
      login_fail:
        "Ошибка аутентификации. Попробуйте снова или обратитесь в школу за помощью.",
      forgot_password: "Забыли пароль",
      create_account: "Создать аккаунт",
      password: "Пароль",
      confirm_password: "Подтвердите пароль",
      password_reminder: "Напоминание пароля",
      enter_email: "Введите ваш email",
      validation_error: "Сообщение об ошибке валидации",
      password_reminder_error_no_user_register:
        "Пользователь не найден. Попробуйте снова или создайте новый аккаунт.",
      password_reminder_error_no_user: "Пользователь не найден.",
      password_reminder_sent: "Письмо с инструкциями отправлено на {email}.",
      password_reminder_sent_message:
        "Письмо может прийти в течение нескольких минут. Проверьте папку «Спам».",
      password_trouble_email: "Если проблема сохраняется, свяжитесь с {email}.",
      password_trouble_school:
        "Если проблема сохраняется, обратитесь в школу за помощью.",
      return_to_sign_in: "Вернуться к входу",
      create_my_account: "Создать аккаунт",
      or_sign_in_with: "ИЛИ ВОЙТИ С ПОМОЩЬЮ",
      password_reset: "Выберите новый пароль для вашего аккаунта.",
      password_reset_warning:
        "Если вы не запрашивали смену пароля, немедленно свяжитесь с администратором школы.",
      password_update: "Выберите новый пароль",
      password_update_confirm: "Подтвердите новый пароль",
      password_update_success: "Ваш новый пароль сохранён."
    },
    AccountSettings: {
      title: "Настройки аккаунта",
      first_name: "Имя",
      last_name: "Фамилия",
      email: "Email",
      username: "Имя пользователя",
      password: "Пароль",
      students: "Ученики",
      teachers: "Учителя",
      external_id: "Внешний ID",
      phone: "Номер телефона",
      edit: "Редактировать",
      remove: "Удалить",
      add: "Добавить",
      remove_message: "Удалить этого ученика?",
      yes: "Да",
      no: "Нет",
      add_student: "Добавить ученика",
      close: "Закрыть",
      save: "Сохранить",
      cancel: "Отмена",
      student_alert_message: "Необходимо указать хотя бы одного ученика.",
      logout: "Выйти"
    },
    Navbar: {
      my_meetings: "Мои встречи",
      language: "Русский",
      help: "Помощь",
      account_settings: "Настройки аккаунта",
      logout: "Выйти"
    },
    SubNavbar: {
      meeting: "Встреча",
      event: "Событие",
      print: "Печать",
      email: "Email",
      export: "Экспорт"
    },
    ConferenceCard: {
      add_edit_meetings: "Добавить/изменить встречи",
      opening: "Открыто",
      closed: "Закрыто"
    },
    Agenda: {
      full_agenda: "Полная повестка",
      empty_state_title: "Для вас нет запланированных конференций.",
      empty_state_message: "По вопросам обращайтесь в школу.",
      confirmation_modal_title: "Повестка подтверждена",
      confirmation_modal_message:
        "Повестка подтверждена. Вам отправлено письмо на email.",
      complete_button: "Готово!"
    },
    AgendaCard: {
      room: "Комната недоступна",
      room_with_value: "Комната: {room}",
      virtual_meeting: "Онлайн-встреча",
      all_conferences: "Все конференции",
      conference: "Конференция",
      student: "Ученик",
      meeting_with: "Встреча с",
      date_time: "Дата/время",
      meeting_type: "Тип встречи",
      location: "Место",
      comment: "Комментарий",
      action: "Действие",
      delete: "Удалить",
      add_comment: "Добавить комментарий",
      join: "Присоединиться",
      choose_meeting_type: "Выберите тип встречи",
      in_person: "Лично",
      phone: "Телефон",
      callback: "Обратный звонок",
      virtual: "Онлайн",
      unavailable: "Недоступно",
      tooltip_translator:
        "Услуги переводчика не гарантированы, но школа приложит все усилия для их предоставления.",
      translator_requested: "Запрошен переводчик",
      clear_translator: "Отменить запрос переводчика",
      need_translator: "Нужен переводчик?",
      choose_language: "Выберите язык"
    },
    ScheduleMatrix: {
      no_teachers_title: "Учителя или команды не выбраны.",
      no_teachers_message: "Выберите учителя для просмотра времени встреч.",
      choose_teachers_button: "Просмотреть доступных учителей",
      choose_student: "Для какого ученика?",
      cancel: "Отмена"
    },
    Matrix: {
      teachers: "Учителя",
      agenda: "Проверить и продолжить"
    },
    DrawerTeachers: {
      teachers: "Учителя",
      name: "Имя",
      description: "Описание",
      student: "Ученик",
      teacher_team: "Учитель/команда",
      show_more: "Показать ещё",
      show_all: "Показать всех учителей школы",
      selected: "({count}) выбрано",
      closeDrawer: "Продолжить планирование",
      search: "Поиск учителя или команды",
      not_available: "У этого учителя нет доступного времени на {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "У вас нет запланированных встреч.",
      no_meetings_message: "После выбора учителя и времени встреча появится здесь.",
      new_meeting_label: "Новая",
      cancel_button: "Отмена",
      student_label: "Ученик",
      meeting_type_location: "Тип встречи/место",
      comment_label: "Комментарий",
      save_comment_button: "Сохранить",
      confirm_label: "Подтвердите:",
      confirm_cancel_button: "Да, отменить встречу с ",
      do_not_cancel_button: "Не отменять",
      confirm_agenda_button: "Подтвердить повестку",
      confirm_agenda_message_line1: "Вы всегда можете вернуться и изменить.",
      confirm_agenda_message_line2: "Повестка будет отправлена вам на email."
    },
    EmailConsent: {
      message:
        "Для защиты вашей конфиденциальности необходимо подтвердить получение сообщений на ваш email.",
      consent: "Согласен"
    }
  }
};
